<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { ControlsContainer, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Components
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	import ThermostatTemperatureWheel from 'src/components/XT1/Thermostat/ThermostatTemperatureWheel.svelte';
	import TemplateThermostatMode from 'src/components/DevicesSettings/VirtualComponents/Templates/components/TemplateThermostatMode.svelte';
	import TemplateStatuses from 'src/components/DevicesSettings/VirtualComponents/Templates/components/TemplateStatuses.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];

	const _device = device;
	$: enable = statuses.find((i) => i.role === 'enable');
	$: thermostatMode = statuses.find((i) => i.role === 'thermostat_mode');
	$: fanMode = statuses.find((i) => i.role === 'fan_mode');
</script>

<div class="flex-full-height" color="color-0">
	<TemplateStatuses {statuses} templateRoles={['current_humidity']} />
	<div class="flex-full-height justify-content-end">
		<ThermostatTemperatureWheel {device} {statuses} />
		<TemplateThermostatMode useV2 {device} status={thermostatMode} />
		<TemplateThermostatMode useV2 {device} status={fanMode} />
		{#if enable}
			<ControlsContainer color="color-0">
				<svelte:fragment slot="first">
					<VirtualBooleanButton
						isWide
						device={_device}
						componentID={enable?.id}
						value={enable?.event}
						useV2Components
					/>
					<Text styleType="controls-large" class="mt-s-plus text-bold"
						>{capFirstChar(
							enable?.event
								? $format('label_action_turn_off', { default: 'turn off' })
								: $format('label_action_turn_on', { default: 'turn on' }),
						)}</Text
					>
				</svelte:fragment>
			</ControlsContainer>
		{/if}
	</div>
</div>
